// src/components/QuickSortControls.js
import React, { useState } from 'react';

const predefinedArrays = [
  [3, 6, 8, 10, 1, 2, 1],
  [5, 2, 9, 1, 5, 6],
  [7, 8, 9, 3, 4, 1, 6]
];

function QuickSortControls({ onStart }) {
  const [inputArray, setInputArray] = useState('');

  const handleInputChange = (e) => setInputArray(e.target.value);

  const handleStartClick = () => {
    const array = inputArray.split(',').map(Number).filter(n => !isNaN(n));
    if (array.length > 0) {
      onStart(array);
    }
  };

  const handlePredefinedSelect = (e) => {
    const index = e.target.value;
    if (index) {
      onStart(predefinedArrays[index]);
    }
  };

  return (
    <div className="controls">
      <input
        type="text"
        value={inputArray}
        onChange={handleInputChange}
        placeholder="Enter comma-separated values"
      />
      <button onClick={handleStartClick}>Start Quick Sort</button>
      <div>
        <label>Select Predefined Array:</label>
        <select onChange={handlePredefinedSelect}>
          <option value="">-- Select an option --</option>
          {predefinedArrays.map((array, index) => (
            <option key={index} value={index}>
              Array {index + 1}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default QuickSortControls;
